import React from "react";

/* ── Asset imports ── */
import HeroBgImg         from "../../asset/images/news/AcusensusTrafficTechnologyHero-bg.webp";
import YoutubeIcon       from "../../asset/images/news/icon-youtube.svg";
import LinkedinIcon      from "../../asset/images/news/icon-linkedin.svg";
import BcSepIcon         from "../../asset/images/news/breadcrumb-separator.svg";
import ProfileIcon       from "../../asset/images/news/icon-profile.svg";
import CalendarIcon      from "../../asset/images/news/icon-calendar.svg";
import ClockIconImg      from "../../asset/images/news/icon-clock.svg";
import CommentsIcon      from "../../asset/images/news/icon-comments.svg";
import PreviousIcon      from "../../asset/images/news/icon-previous.svg";
import NextIcon          from "../../asset/images/news/icon-next.svg";
import FacebookIcon      from "../../asset/images/news/icon-facebook.svg";
import TwitterIcon       from "../../asset/images/news/icon-twitter.svg";
import LinkedinShareIcon from "../../asset/images/news/icon-linkedin-share.svg";

/* ── Recent post thumbnails ── */
import RecentImg1 from "../../asset/images/news/news-1.webp";
import RecentImg2 from "../../asset/images/news/news-2.webp";
import RecentImg3 from "../../asset/images/news/news-3.webp";
import RecentImg4 from "../../asset/images/news/news-4.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .actt { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══ HERO ══ */
  .actt-hero {
    position: relative; width: 100%; height: 460px;
    overflow: hidden;
  }
  .actt-hero-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover; object-position: center right; display: block;
  }
  .actt-hero-overlay {
    position: absolute; inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.85) 0%,
    //   rgba(0,0,0,0.65) 38%,
    //   rgba(0,0,0,0.10) 100%
    // );
  }
  .actt-hero-content {
    position: absolute; inset: 0;
    display: flex; flex-direction: column; justify-content: center;
    padding: 0 102px;
    max-width: 1600px; margin: 0 auto; left: 0; right: 0;
  }
  .actt-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px; font-weight: 600; color: #fff;
    line-height: 120%; margin-bottom: 15px; max-width: 575px;
  }
  .actt-hero-divider {
    width: 575px; height: 2px;
    background: #EB2019; border: none; margin-bottom: 15px;
  }
  .actt-hero-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #fff;
    line-height: 160%; max-width: 479px;
  }

  /* ══ BREADCRUMB ══ */
  .actt-breadcrumb { width: 100%; padding: 40px 0 0 0; }
  .actt-breadcrumb-inner {
    max-width: 1600px; margin: 0 auto; padding: 0 102px;
    display: flex; align-items: center; flex-wrap: wrap;
  }
  .actt-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 500; color: #202020;
    text-decoration: none; display: flex; align-items: center; gap: 14px;
    transition: color 0.15s;
  }
  .actt-bc-item:hover { color: #EB2019; }
  .actt-bc-sep {
    display: flex; align-items: center; justify-content: center;
    width: 24px; height: 24px; border-radius: 50%;
    margin: 0 8px; flex-shrink: 0;
  }
  .actt-bc-sep img { width: 24px; height: 24px; display: block; }
  .actt-bc-item.active { color: #202020; font-weight: 500; }

  /* ══ INNER ══ */
  .actt-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; }

  /* ══ MAIN ══ */
  .actt-main-section { padding: 80px 0 120px 0; }
  .actt-main-row { display: flex; align-items: flex-start; gap: 89px; }

  /* ══ ARTICLE ══ */
  .actt-article { flex: 1; min-width: 0; }

  .actt-meta-bar {
    display: flex; align-items: center; flex-wrap: wrap; gap: 20px;
    margin-bottom: 30px;
  }
  .actt-meta-item {
    display: flex; align-items: center; gap: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    border-right: 1px solid #7A7A7A; padding-right: 15px;
  }
  .actt-meta-item:last-child { border-right: none; padding-right: 0; }
  .actt-meta-item img { width: 24px; height: 24px; display: block; flex-shrink: 0; }

  .actt-article-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px; font-weight: 600; color: #202020;
    line-height: 140%; margin-bottom: 30px;
  }

  .actt-article-body {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .actt-article-body p { margin-bottom: 20px; }
  .actt-article-body p:last-child { margin-bottom: 0; }

  .actt-article-body strong { font-weight: 600; color: #202020; }

  .actt-red-link-plain { color: #EB2019; text-decoration: underline; font-weight: 600; }
  .actt-red-link-plain:hover { opacity: 0.8; }

  /* ══ BOTTOM ROW ══ */
  .actt-bottom-row {
    display: flex; align-items: center; justify-content: space-between;
    margin-top: 30px; padding-top: 30px;
    border-top: 1px solid #C7C7C7; flex-wrap: wrap; gap: 16px;
  }
  .actt-bottom-nav { display: flex; align-items: center; gap: 60px; }
  .actt-nav-btn {
    display: inline-flex; align-items: center; gap: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px; font-weight: 500; color: #202020;
    text-decoration: none; background: none; border: none;
    cursor: pointer; transition: color 0.15s;
  }
  .actt-nav-btn:hover { color: #EB2019; }
  .actt-nav-btn img { width: 40px; height: 40px; display: block; }

  .actt-share-icons { display: flex; align-items: center; gap: 20px; }
  .actt-share-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 50%;
    text-decoration: none; flex-shrink: 0; transition: opacity 0.15s;
  }
  .actt-share-icon:hover { opacity: 0.85; }
  .actt-share-icon img { width: 44px; height: 44px; display: block; }

  /* ══ SIDEBAR ══ */
  .actt-sidebar { flex: 0 0 475px; }
  .actt-sidebar-block { margin-bottom: 60px; }
  .actt-sidebar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px; font-weight: 600; color: #202020;
    margin-bottom: 30px; padding-bottom: 20px;
    border-bottom: 1px solid #EB2019; line-height: 120%;
  }
  .actt-recent-list { display: flex; flex-direction: column; gap: 30px; }
  .actt-recent-item {
    display: flex; align-items: flex-start; gap: 12px;
    text-decoration: none; color: #202020;
  }
  .actt-recent-item:hover .actt-recent-title { color: #EB2019; }
  .actt-recent-img {
    flex: 0 0 200px; height: 120px;
    object-fit: cover; border-radius: 6px; display: block;
  }
  .actt-recent-body { flex: 1; min-width: 0; }
  .actt-recent-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; transition: color 0.15s;
    display: -webkit-box; -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; overflow: hidden;
  }
  .actt-social-icons { display: flex; align-items: center; gap: 30px; }
  .actt-social-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 6px; overflow: hidden;
    text-decoration: none; transition: opacity 0.15s;
  }
  .actt-social-icon:hover { opacity: 0.8; }
  .actt-social-icon img { width: 44px; height: 44px; object-fit: contain; display: block; }

  /* ══ RESPONSIVE — TABLET ══ */
  @media (max-width: 768px) {
    .actt-hero             { height: 350px; }
    .actt-hero-content     { padding: 0 32px; }
    .actt-hero-title       { font-size: 30px; }
    .actt-hero-divider     { width: 100%; max-width: 575px; }
    .actt-breadcrumb       { padding: 24px 0 0 0; }
    .actt-breadcrumb-inner { padding: 0 32px; }
    .actt-inner            { padding: 0 32px; }
    .actt-main-section     { padding: 48px 0 60px 0; }
    .actt-main-row         { flex-direction: column; gap: 48px; }
    .actt-sidebar          { flex: none; width: 100%; }
    .actt-article-title    { font-size: 20px; }
  }

  /* ══ RESPONSIVE — MOBILE ══ */
  @media (max-width: 480px) {
    .actt-hero             { height: 360px; }
    .actt-hero-content     { padding: 0 16px; }
    .actt-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .actt-hero-divider     { width: 100%; }
    .actt-hero-subtitle    { font-size: 14px; }
    .actt-breadcrumb       { padding: 30px 0 0 0; }
    .actt-breadcrumb-inner { padding: 0 16px; }
    .actt-bc-item          { font-size: 14px; gap: 14px; }
    .actt-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .actt-bc-sep img       { width: 22px; height: 22px; }
    .actt-inner            { padding: 0 16px; }
    .actt-main-section     { padding: 30px 0 60px 0; }
    .actt-main-row         { flex-direction: column; gap: 60px; }
    .actt-sidebar          { flex: none; width: 100%; }
    .actt-article-title    { font-size: 20px; margin-bottom: 15px; }
    .actt-article-body     { font-size: 14px; }
    .actt-article-body p   { margin-bottom: 15px; }
    .actt-article-body strong { font-size: 16px; }
    .actt-meta-item        { font-size: 14px; }
    .actt-meta-item:nth-child(2) { border-right: none; padding-right: 0; }
    .actt-nav-btn img      { width: 24px; height: 24px; }
    .actt-nav-btn          { font-size: 14px; }
    .actt-share-icon img   { width: 34px; height: 34px; }
    .actt-sidebar-title    { font-size: 20px; }
    .actt-bottom-nav       { gap: 20px; }
  }
`;

const recentPosts = [
  {
       img: RecentImg1,
       title: "Battery Formation & Testing: Enabling The Rise Of EV & Energy Storage Manufacturing",
       slug: "battery-formation-testing-enabling-the-rise-of-ev-energy-storage-manufacturing/",
     },
     {
       img: RecentImg2,
       title: "Next-Gen ESP Power Supplies: Upgrades and Sustainability in Industrial Air Pollution Control",
       slug: "next-gen-esp-power-supplies-upgrades-and-sustainability-in-industrial-air-pollution-control/",
     },
     {
       img: RecentImg3,
       title: "Green Hydrogen Power Electronics: Ador Powertron at the Forefront of Electrolyzer Rectifier Setups",
       slug: "green-hydrogen-power-electronics-ador-powertron-at-the-forefront-of-electrolyzer-rectifier-setups/",
     },
     {
       img: RecentImg4,
       title: "Transformer Bushings: Types & Importance",
       slug: "transformer-bushings-guide/",
     },
];

export default function AcusensusTrafficTechnology() {
  return (
    <div className="actt">
      <style>{CSS}</style>

      {/* ══ HERO ══ */}
      <section className="actt-hero">
        <img className="actt-hero-bg" src={HeroBgImg} alt="Acusensus featured in Traffic Technology International Hero" />
        <div className="actt-hero-overlay" />
        <div className="actt-hero-content">
          <h1 className="actt-hero-title">
            Acusensus featured in cover story of the latest issue of Traffic Technology International
          </h1>
          <hr className="actt-hero-divider" />
          <p className="actt-hero-subtitle">
            Everything we do is designed, whether we're producing a magazine, a website, or a bridge. Design is really the creative invention that designs everything.
          </p>
        </div>
      </section>

      {/* ══ BREADCRUMB ══ */}
      <nav className="actt-breadcrumb" aria-label="Breadcrumb">
        <div className="actt-breadcrumb-inner">
          <a href="/" className="actt-bc-item">Home</a>
          <span className="actt-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/news" className="actt-bc-item">News &amp; Updates</a>
          <span className="actt-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="actt-bc-item active">Post</span>
        </div>
      </nav>

      {/* ══ MAIN ══ */}
      <section className="actt-main-section">
        <div className="actt-inner">
          <div className="actt-main-row">

            {/* ── ARTICLE ── */}
            <article className="actt-article">

              {/* Meta bar */}
              <div className="actt-meta-bar">
                <span className="actt-meta-item"><img src={ProfileIcon} alt="author" /> Admin</span>
                <span className="actt-meta-item"><img src={CalendarIcon} alt="date" /> March 26, 2024</span>
                <span className="actt-meta-item"><img src={ClockIconImg} alt="time" /> 11:04 am</span>
                <span className="actt-meta-item"><img src={CommentsIcon} alt="comments" /> No Comments</span>
              </div>

              {/* Title */}
              <h1 className="actt-article-title">
                Acusensus featured in cover story of the latest issue of Traffic Technology International
              </h1>

              {/* Body */}
              <div className="actt-article-body">

                <p>Detecting drivers who are using phones at the wheel has long been a labor intensive manual task. But now the worlds first automated solutions are already here.</p>

                <p>Our partners at Acusensus are featured as one of the key innovators in this space. The article tackles distracted driving from a behavioral, legal and technological perspectives.</p>

                <p>Click here to read the complete article: <a href="https://journal-download.co.uk/digitalmagazines/TTI/TTI01JUL2019/page_23.html" className="actt-red-link-plain" target="blank">Danger at the Wheel</a></p>

              </div>

              {/* ── Bottom row ── */}
              <div className="actt-bottom-row">
                <div className="actt-bottom-nav">
                  <a href="/news/motorists-mobile-phone-driving" className="actt-nav-btn">
                    <img src={PreviousIcon} alt="Previous" />
                    Previous
                  </a>
                  <a href="/news/designing-efficient-smps-coal" className="actt-nav-btn">
                    Next
                    <img src={NextIcon} alt="Next" />
                  </a>
                </div>
                <div className="actt-share-icons">
                  <a href="https://www.facebook.com/sharer.php?u=https://adorpowertron.com/acusensus-featured-in-cover-story-of-the-latest-issue-of-traffic-technology-international/" className="actt-share-icon" aria-label="Facebook" target="blank">
                    <img src={FacebookIcon} alt="Facebook" />
                  </a>
                  <a href="https://x.com/i/jf/onboarding/web?redirect_after_login=%2Fintent%2Ftweet%3Ftext%3D%2520https%3A%2F%2Fadorpowertron.com%2Facusensus-featured-in-cover-story-of-the-latest-issue-of-traffic-technology-international%2F&mode=login" className="actt-share-icon" aria-label="Twitter" target="blank">
                    <img src={TwitterIcon} alt="Twitter" />
                  </a>
                  <a href="https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2FshareArticle%3Fmini%3Dtrue%26url%3Dhttps%3A%2F%2Fadorpowertron.com%2Facusensus-featured-in-cover-story-of-the-latest-issue-of-traffic-technology-international%2F%26title%3DAcusensus%2520featured%2520in%2520Traffic%2520Technology%2520International%2520%257C%2520Ador%26summary%3D%26source%3Dhttps%3A%2F%2Fadorpowertron.com%2Facusensus-featured-in-cover-story-of-the-latest-issue-of-traffic-technology-international%2F" target="blank" className="actt-share-icon" aria-label="LinkedIn">
                    <img src={LinkedinShareIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </article>

            {/* ── SIDEBAR ── */}
            <aside className="actt-sidebar">

              {/* Recent Posts */}
              <div className="actt-sidebar-block">
                <p className="actt-sidebar-title">Recent Posts</p>
                <div className="actt-recent-list">
                  {recentPosts.map((post, idx) => (
                    <a key={idx} href={`/news/${post.slug}`} className="actt-recent-item">
                      <img src={post.img} alt={post.title} className="actt-recent-img" />
                      <div className="actt-recent-body">
                        <span className="actt-recent-title">{post.title}</span>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="actt-sidebar-block">
                <p className="actt-sidebar-title">Social Media</p>
                <div className="actt-social-icons">
                  <a href="https://www.youtube.com/@adorIndia" className="actt-social-icon" aria-label="YouTube" target="blank">
                    <img src={YoutubeIcon} alt="YouTube" />
                  </a>
                  <a href="https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2F139191%2Fadmin%2F" className="actt-social-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </aside>

          </div>
        </div>
      </section>

    </div>
  );
}